const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** Formats an ISO date (YYYY-MM-DD) as "Oct 2, 2026" the same way on server and client. */
export const formatDate = (value: string): string => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)

    if (!match) return value

    const month = MONTHS[Number(match[2]) - 1] ?? ''

    return `${month} ${Number(match[3])}, ${match[1]}`
}

/** Thousands separators without relying on the runtime locale. */
export const formatNumber = (value: number): string => {
    return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/** Two-letter initials for avatars and monogram tiles. */
export const initials = (name: string): string => {
    const words = name.replace(/[^A-Za-z0-9À-ɏ\s]/g, ' ').split(/\s+/).filter(Boolean)

    if (words.length === 0) return '?'
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase()

    return `${words[0][0]}${words[1][0]}`.toUpperCase()
}

/** Small deterministic hash, used to derive generated covers and tints from a seed. */
export const hashString = (value: string): number => {
    let hash = 2166136261

    for (let index = 0; index < value.length; index++) {
        hash ^= value.charCodeAt(index)
        hash = Math.imul(hash, 16777619)
    }

    return hash >>> 0
}

export const slugify = (value: string): string => {
    return value
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
}

export const isValidEmail = (value: string): boolean => {
    return /^[^\s@<>()[\]\\,;:"]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(value.trim())
}
